import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import {employee } from '../models/employee.model';
import { baseSearchModel } from "src/app/shared/models/baseSearchModel";
import { EmployeeModel } from '../models/employeeModel';

@Injectable({
  providedIn: 'root'
})
export class EmployeeService {
  constructor(private _http : HttpClient) { }
  getBlankEmployee() : Observable<any>{
    return this._http.get<any>(environment.config.BASE_API_URL + "Employee/GetEmployee"); 
  }

searchEmployees(searchCriteria: baseSearchModel): Observable<any> {
    return this._http.post<any>(environment.config.BASE_API_URL + 'Employee/PostEmployeeSearch', searchCriteria);
 }

getEmployee(employeeId): Observable<any> {
  return this._http.get<any>(environment.config.BASE_API_URL + 'Employee?employeeId=' + employeeId);
}

postEmployeeProfile(updateEmployeeData): Observable<any> {
  
  return this._http.post<any>(environment.config.BASE_API_URL + 'Employee/PostEmployeeProfilee', updateEmployeeData);
}

}